export const SET_BANNER = 'set-banner';
export const SET_CURRENT_BANNER_ID = 'set-current_banner_id';
export const SET_BANNER_LOADER = 'set-banner-loader';
export const SET_OUTLET_BANNER_LOADER = 'set-outlet-banner-loader';
export const SET_CURRENT_BANNERS_SCREEN = 'set_current_banners_screen';
